import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=d6ee085a&"
import script from "./BackButton.vue?vue&type=script&lang=js&"
export * from "./BackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports